<template>
  <v-tooltip
    top
    right
    color="primary"
    :disabled="disabled || (!text && !$slots.tooltip)"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        :class="contentClass"
        class="w-fit"
        v-bind="attrs"
        v-on="on"
        @mouseenter="getHTMLText"
      >
        <slot></slot>
      </div>
    </template>
    <span v-if="text" v-html="text"></span>
    <fragment v-else>
      <div
        v-if="isPlainTextSlot"
        style="max-width: 500px; text-wrap: wrap"
        class="break-all line-clamp-20"
        v-html="htmlText"
      ></div>
      <div
        v-else
        class="break-all line-clamp-20"
        style="max-width: 500px; text-wrap: wrap"
      >
        <slot name="tooltip"></slot>
      </div>
    </fragment>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    /** The tooltip description. */
    text: {
      type: [String, Number],
      default: "",
    },
    /** If **true** the tooltip will not display. */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Customization class for content. */
    contentClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return { htmlText: "" };
  },
  computed: {
    /** Returns the text as a string. */
    isPlainTextSlot() {
      const slot = this.$slots.tooltip;

      // No slot or empty
      if (!slot || slot.length === 0) return false;

      // Check if all nodes are text nodes (no tag, just text)
      return slot.every(
        (node) =>
          (!node.tag && typeof node.text === "string") ||
          (node.children &&
            Array.isArray(node.children) &&
            node.children.every(
              (child) => !child.tag && typeof child.text === "string",
            )),
      );
    },
  },
  watch: {
    // Watch for changes in the default slot content
    "$slots.tooltip": {
      handler() {
        this.getHTMLText();
      },
      immediate: true,
    },
    "$i18n.locale": {
      handler() {
        // Force re-evaluation of computed properties when locale changes
        this.getHTMLText();
      },
      immediate: true,
    },
  },
  methods: {
    // Method to update the tooltip content
    getHTMLText() {
      const slot = this.$slots.tooltip;
      if (!!this.text || !this.isPlainTextSlot || !slot) {
        this.htmlText = "";
        return;
      }
      this.htmlText = slot
        ? slot
            .map((node) => {
              if (typeof node === "string") return node;
              if (node.text) return node.text;
              if (node.children) {
                return node.children
                  .map((child) => (typeof child === "string" ? child : ""))
                  .join("");
              }
              return "";
            })
            .join("")
        : "";
    },
  },
};
</script>

<style scoped></style>
